import { render } from "./Calender.vue?vue&type=template&id=626a3388&scoped=true"
import script from "./Calender.vue?vue&type=script&lang=js"
export * from "./Calender.vue?vue&type=script&lang=js"

import "./Calender.vue?vue&type=style&index=0&id=626a3388&lang=scss&scoped=true"

import exportComponent from "D:\\digitalnewspaper\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-626a3388"]])

export default __exports__